export const LOGOUT_SUCCESSFUL = 'LOGOUT_SUCCESSFUL';
export const PASSWORD_RESET_FAIL = 'PASSWORD_RESET_FAIL';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_CONFIRM_FAIL = 'PASSWORD_RESET_CONFIRM_FAIL';
export const PASSWORD_RESET_CONFIRM_SUCCESS = 'PASSWORD_RESET_CONFIRM_SUCCESS';
export const ACTIVATION_FAIL = 'ACTIVATION_FAIL';
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS';
